import React, { useEffect, useRef } from 'react';

const Pillow = ({ texture }) => {
  const mesh = useRef();
  
  useEffect(() => {
    if (mesh.current) {
      mesh.current.rotation.z = -0.25;
    }
  }, []);

  return (
    <mesh
      position={[-4, -0.75, 0]}
      ref={mesh}
      scale={[1, 1, 1]}
    >
      <boxGeometry args={[2, 1, 3.5]} />
      <meshStandardMaterial map={texture} />
    </mesh>
  );
};

export default Pillow;
